import React, { useEffect, useState } from 'react'
// @common
import Cookies from 'universal-cookie'
import Button from '@bit/atd.web.button'
import Modal from '@bit/atd.web.modal'
import { addYears } from 'date-fns'
// @components
import { Typography } from '@material-ui/core'
import strings from 'lib/constants/strings'

const WelcomeModal = () => {
  const cookies = new Cookies()
  const COOKIES_NAME = 'WelcomeModal'
  const [isShown, setIsShown] = useState(false)
  useEffect(() => {
    if (!cookies.get(COOKIES_NAME)) {
      setIsShown(true)
    }
  }, [])
  const close = () => {
    cookies.set(COOKIES_NAME, 'WelcomeModal', {
      path: '/',
      expires: addYears(new Date(), 365),
      domain: '.td.org',
    })
    setIsShown(false)
  }
  return (
    <Modal
      onClose={close}
      footerNoSeparator
      headerNoSeparator
      open={isShown}
      size="large"
      title={strings.DASHBOARD.WELCOME_MODAL.TITLE}
      footerAlign="center"
      actions={
        <div>
          <Button variant="primary" size="medium" onClick={close}>
            {strings.DASHBOARD.WELCOME_MODAL.CTA}
          </Button>
        </div>
      }
    >
      <Typography component={'p'}>
        {strings.DASHBOARD.WELCOME_MODAL.DESCRIPTION}
      </Typography>
    </Modal>
  )
}

export default WelcomeModal
